import React, { createContext, useContext, useState } from 'react';

const GlobalBackButtonContext = createContext();

export const useGlobalBackButton = () => useContext(GlobalBackButtonContext);

export const GlobalBackButtonProvider = ({ children }) => {
    const [ onBack, setOnBack ] = useState(null);

    return (
        <GlobalBackButtonContext.Provider value={{ onBack, setOnBack }}>
            {children}
        </GlobalBackButtonContext.Provider>
    );
};
